export let _devmode_global = false;
export let _appConfigPanels = [1, 2];
export let _appConfigLocations = [1];
export let _appConfigDefaultLocation = 1;
export let _appConfigStations = 12